import { render, staticRenderFns } from "./SingleLayout.vue?vue&type=template&id=6be68a83&"
import script from "./SingleLayout.vue?vue&type=script&lang=js&"
export * from "./SingleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QPageContainer} from 'quasar'
component.options.components = Object.assign({QLayout,QPageContainer}, component.options.components || {})
